import errors from './errors';

export const tokenNotValid = {
  status: 401,
  code: 'NOT_VALID_TOKEN',
  message: errors.tokenIsNotValid
};

export const internalServerError = {
  status: 500,
  message: errors.internalServerError
};

export const badGateway = {
  status: 504,
  message: errors.badRequest
};

export const apiVersionMismatch = {
  status: 426,
  message: errors.apiVersionMismatch
};

export const noNetworkConnection = {
  status: 'Failed to fetch',
  message: errors.noNetworkConnection
};
